import React from 'react';
import { Lip_BA_Hero, SEO } from '../../../components';
import { graphql } from 'gatsby';
import '../process.css';

function BeforeAfterLip() {
  return (
    <main id='beforeafter_lip-page'>
      <Lip_BA_Hero />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Face Before & After Photos of Laser Hair Removal | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Discover the amazing transformation before and after lip laser hair removal. See the incredible results for yourself!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default BeforeAfterLip;
